/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const useUpgradeClusterDialogStyles = makeStyles({
  icon: {
    marginTop: '2px',
  },
  popover: {
    padding: '10px 15px',
  },
});
